<div class="text-xl font-semibold leading-tight">
    <div class="flex text-xl text-center mt-5">
        <span translate [translateParams]="{language:lilate.language.label}">
            lilate-exam.certif.name.1
        </span>
    </div>
    <div class="flex w-full justify-center mt-5">
        <img class="w-6 h-6 ml-2" src="{{lilate.language.flag}}" alt="language-flag">
    </div>
</div>
<div class="font-medium my-5 text-center text-secondary">
    <div
        [translate]="absentDateKey"
        [translateParams]="{ date: lilate.start | amLocale: 'fr' | amDateFormat:'DD MMMM YYYY' }">
    </div>
</div>

<hr class="w-full border-t my-6">

<div class="text-center text-secondary" translate>
    lilate-exam.session-content.absent-info
</div>
